import { render, staticRenderFns } from "./Bg.vue?vue&type=template&id=387fdfab&scoped=true&"
import script from "./Bg.vue?vue&type=script&lang=js&"
export * from "./Bg.vue?vue&type=script&lang=js&"
import style0 from "./Bg.vue?vue&type=style&index=0&id=387fdfab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387fdfab",
  null
  
)

export default component.exports